export function getLabelValueExchangedRowValues(
  rowValues: readonly string[],
  shouldExchangeLabelValue: boolean
): string[] {
  if (!shouldExchangeLabelValue || rowValues.length < 2) {
    return [...rowValues];
  }

  const exchangedRowValues: string[] = [...rowValues];
  [exchangedRowValues[0], exchangedRowValues[1]] = [exchangedRowValues[1], exchangedRowValues[0]];
  return exchangedRowValues;
}
